import { useQuery } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { fetchTicketDetail } from "../Services/fetchTicketDetail";

export default function useTallerTicketDetail({ ticketId, countryId }) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: ["serviceOperation", "tallerTicketDetail", { ticketId, countryId }],
    queryFn: () => fetchTicketDetail({ accessToken, ticketId, countryId }),
    staleTime: 0,
    enabled: !!ticketId && !!countryId && !!accessToken,
    retry: false,
  });
}